// extracted by mini-css-extract-plugin
export default {"imageBox":"ImageUploader_imageBox__4cIqr"};